import { render, staticRenderFns } from "./DeposltoryInfo.vue?vue&type=template&id=53cdeee8&scoped=true"
import script from "./DeposltoryInfo.vue?vue&type=script&lang=js"
export * from "./DeposltoryInfo.vue?vue&type=script&lang=js"
import style0 from "./DeposltoryInfo.vue?vue&type=style&index=0&id=53cdeee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cdeee8",
  null
  
)

export default component.exports